// extracted by mini-css-extract-plugin
export var image = "article-rich-text-module--image--9deac";
export var root = "article-rich-text-module--root--f5cd5";